export class Unit {

  executeArray = (items, itemsExists) => {
    let units = [...itemsExists.units]

    for (let itemIdex in units) {
      let item = units[itemIdex];

      let index = items.findIndex(x => x.CUnits_id == item.id || x.id == item.id)
      if (index > -1) {
        item = this.getProcessItem(item, items[index]);
        units[itemIdex] = item;
      }
    }

    return [true, { units: [...units] }]
  }

  execute = (item, itemsExists) => {
    let units = itemsExists.units
    let index = units.findIndex(x => x.id == item.CUnits_id || x.id == item.id)
    if (index != -1)
      units[index] = this.getProcessItem(units[index], item)

    return [true, { units: [...units] }]
  }

  getProcessItem = (item, newItem) => {
    let tags = item?.tags || [];
    if (newItem?.tags && Array.isArray(newItem?.tags)) {
      tags = newItem?.tags;
    }

    let objItem = {
      ...item,
      label: newItem.Label || newItem.label || item.label,
      esn: newItem.USN || item.esn,
      tags: tags
    }

    return objItem
  }

}